<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-card class="rounded-lg" elevation="1">
          <v-card-title color="#f8f9fb" elevation="0">
            <v-row align="center" no-gutters>
              <v-col cols="auto">
                <span class="text-h6 font-weight-regular">{{
                  $t("membersrequest.title")
                }}</span>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="12" sm="4" md="3" class="px-3">
                <v-text-field
                  v-model="search"
                  label="Search"
                  append-icon="mdi-magnify"
                  single-line
                  hide-details
                  clearable
                  @input="sessionStorage(search)"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="3">
                <v-autocomplete
                  v-model="selected_flat"
                  label="Flat"
                  :items="flats"
                  item-text="name"
                  item-value="id"
                  outlined
                  dense
                  hide-details
                  clearable
                  @change="getMembers()"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-card-title>
          <v-divider></v-divider>
          <v-data-table
            :headers="headers"
            :items="members"
            :search="search"
          >
              <template v-slot:item.mobile_no="{ item }">
                {{ (item.country_code) }} {{ (item.mobile_no) }}
              </template>
              <template v-slot:item.house_number="{ item }">
                <span v-if="item.flat">{{ item.flat.name }}-</span>
                <span>{{ item.house_number }}</span>

                <!-- {{ item.house_number }} {{item.flat.name}} -->
              </template>
              <template v-slot:item.last_active_time="{ item }">
                {{ getFormattedDate(item.last_active_time) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      small
                      color="secondary"
                      v-bind="attrs"
                      style="margin-left: -10px"
                      v-on="on"
                      :to="'/societyadmin/house/view/' + item.id"
                    >
                      <img src="@/components/icons/view.svg" width="18" height="18" />
                    </v-btn>
                  </template>
                  <span>View Details</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      small
                      color="secondary"
                      v-bind="attrs"
                      v-on="on"
                      @click="confirmacceptMemeberRequest(item)"
                    >
                      <v-icon small v-bind="attrs" v-on="on">
                        mdi-check-bold
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Accept</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      small
                      color="secondary"
                      v-bind="attrs"
                      v-on="on"
                      @click="confirmrejectMemeberRequest(item)"
                    >
                      <v-icon small v-bind="attrs" v-on="on">
                        mdi-close-thick
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Reject</span>
                </v-tooltip>
              </template>
            </v-data-table>
        </v-card>
      </v-flex>
      <v-dialog v-model="deleteDialog" width="500">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Confirm!!
          </v-card-title>
          <v-card-text class="mt-2">Are you sure want to delete? </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="deleteHouse(delete_id)">
              yes
            </v-btn>
            <v-btn color="primary" text @click="deleteDialog = false">
              No
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="AcceptDialog" width="500">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Confirm!!
          </v-card-title>
          <v-card-text class="mt-2">Are you sure want to Approve? </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="acceptMemeberRequest(accept_id)"
            >
              yes
            </v-btn>
            <v-btn color="primary" text @click="closeDialog"> No </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="RejectDialog" width="500">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Confirm!!
          </v-card-title>
          <v-card-text class="mt-2">Are you sure want to Reject? </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="rejectMemberRequest(reject_id)">
              yes
            </v-btn>
            <v-btn color="primary" text @click="closeDialog"> No </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      search: "",
      headers: [
        {
          text: `${this.$t("membersrequest.headers.houseNo")}`,
          value: "house_number",
        },
        {
          text: `${this.$t("membersrequest.headers.personName")}`,
          value: "name",
          width: "30%",
        },
        {
          text: `${this.$t("membersrequest.headers.ContactNo")}`,
          value: "mobile_no",
        },
        {
          text: `${this.$t("membersrequest.headers.LastActiveTime")}`,
          value: "last_active_time",
          sortable: false,
        },
        {
          text: `${this.$t("membersrequest.headers.action")}`,
          value: "actions",
          sortable: false,
        },
        {},
      ],
      user: {},
      addPermissionDialog: false,
      members: [],
      deleteDialog: false,
      AcceptDialog: false,
      RejectDialog: false,
      flats: [],
      selected_flat: null,
      accept_id: "",
      reject_id: "",
    };
  },
  methods: {
    ...mapMutations("alert", ["setAlert"]),
    getMembers() {
      let _self = this;
      _self.$axios
        .get(
          "societyadmin/requestList?flat_id="+
            _self.selected_flat
        )
        .then((response) => {
          let data = response.data;
          if (data.status) {
            _self.members = data.members;
          } else {
            _self.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
            if (data.type == "invalid") {
              localStorage.removeItem("user");
              _self.$router.push({ path: "/societyadmin/login" });
            }
          }
        });
    },
    deleteHouse(houseId) {
      let _self = this;

      _self.$axios
        .delete("societyadmin/members/" + houseId)
        .then((response) => {
          let data = response.data;

          if (data.status) {
            let index = this.members.findIndex((record) => {
              return record.id == houseId;
            });

            if (index != -1) {
              this.members.splice(index, 1);
            }
            this.deleteDialog = false;
            this.setAlert({
              showAlert: true,
              variant: "green accent-4",
              timeout: "2000",
              message: data.message,
            });
          } else {
            this.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
          }
        });
    },
    getFormattedDate(date) {
      return date ? moment(date).format("DD-MM-YYYY hh:mm A") : "N/A";
    },
    confirmacceptMemeberRequest(member) {
      (this.AcceptDialog = true), (this.accept_id = member);
    },
    confirmrejectMemeberRequest(member) {
      (this.RejectDialog = true), (this.reject_id = member);
    },
    sessionStorage(search) {
      if (search === null || search === "" || search === undefined) {
        sessionStorage.removeItem("house_search");
      } else {
        sessionStorage.setItem("house_search", search);
      }
    },
    acceptMemeberRequest(member) {
      let _self = this;
      _self.$axios
        .post("societyadmin/members/request/accept/" + member.id)
        .then((response) => {
          let data = response.data;

          if (data.status) {
            this.closeDialog();
            let index = _self.members.indexOf(member);
            index != -1 ? _self.members.splice(index, 1) : "";
            _self.setAlert({
              showAlert: true,
              variant: "green accent-4",
              timeout: "2000",
              message: data.message,
            });
          } else {
            _self.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
          }
        });
    },
    getFlats() {
      let _self = this;
      _self.$axios.get("societyadmin/flats").then((response) => {
        let data = response.data;

        if (data.status) {
          let modifiedFlats = [...data.flats];
          modifiedFlats.unshift({ id: "single_house", name: "Single House" });
          _self.flats = modifiedFlats;
        } else {
          _self.setAlert({
            showAlert: true,
            variant: "red accent-3",
            timeout: "2000",
            message: data.message,
          });
        }
      });
    },
    closeDialog() {
      this.AcceptDialog = false;
      this.RejectDialog = false;
      this.accept_id = "";
      this.reject_id = "";
    },

    rejectMemberRequest(member) {
      let _self = this;

      _self.$axios
        .post("societyadmin/members/request/reject/" + member.id)
        .then((response) => {
          let data = response.data;

          if (data.status) {
            this.closeDialog();
            let index = _self.members.indexOf(member);
            index != -1 ? _self.members.splice(index, 1) : "";

            _self.setAlert({
              showAlert: true,
              variant: "green accent-4",
              timeout: "2000",
              message: data.message,
            });
          } else {
            _self.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
          }
        });
    },
    
  },
  mounted() {
    this.user = localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : {};
    this.getMembers();
    this.getFlats();
    this.search = sessionStorage.getItem("house_search");
  },
};
</script>